import React, { useEffect, useState } from "react";
import ModalLayout from "../../../../../components/ModalLayout";
import { Box, Typography, useTheme } from "@mui/material";
import { useAppDispatch } from "../../../../../../hooks/useRedux";
import useSWRMutation from "swr/mutation";
import {
  setOpenSnackbar,
  setSnackbarDescription,
  setSnackbarErrorStatus,
} from "../../../../../../redux/features/snackbarSlice";
import { fetcherPost } from "../../../../../../services/fetcher";
import { addCommas } from "@persian-tools/persian-tools";
import CustomButton from "../../../../../components/CustomButton";
import { useInView } from "react-intersection-observer";
import { DotLoader } from "react-spinner-overlay";
import EmptyCargoSVG from "../../../../../../media/images/icons/empty-cargo";
import { blueGrey } from "@mui/material/colors";

interface Props {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  orderId: string;
  id: string;
  status: number;
  price: number;
}

interface ITender {
  driverFullName: "رضا خورشا";
  price: 80000;
}

export default function TenderDeatailsModal(props: Props) {
  const { open, setOpen, orderId } = props;

  const theme = useTheme();

  const dispatch = useAppDispatch();

  const [tendersList, setTendersList] = useState<ITender[]>([]);

  const [pageCounts, setPageCounts] = useState(0);

  const [pageN, setPageN] = useState(1);
  const { ref, inView } = useInView({
    /* Optional options */
    threshold: 0,
  });
  const { trigger: getTendersList, isMutating: isGetTendersListMutting } =
    useSWRMutation(
      [`/DriverPriceReq/OwnerSearch`, localStorage.getItem("access_token")],
      fetcherPost,
      {
        onSuccess: (data) => {
          setTendersList(data.data);
          setPageCounts(data.count);
        },
      }
    );

  const {
    trigger: getTendersListNextPage,
    isMutating: isGetTendersListMuttingNextPage,
  } = useSWRMutation(
    [`/DriverPriceReq/OwnerSearch`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: (data) => {
        setTendersList([...tendersList, ...data.data]);
      },
    }
  );

  useEffect(() => {
    if (open) {
      getTendersList({
        orderId,
        pageNr: 1,
      });
    }
  }, [open]);

  useEffect(() => {
    if (inView && pageCounts > tendersList.length) {
      setPageN((prev) => prev + 1);
    }
  }, [inView]);

  useEffect(() => {
    getTendersListNextPage({
      pageNr: pageN,
      orderId,
    });
  }, [pageN, getTendersListNextPage, orderId]);

  return (
    <ModalLayout open={open} setOpen={setOpen}>
      <Box
        sx={{
          flex: 1,
          paddingX: "8px",
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        {isGetTendersListMutting ? (
          <Box
            sx={{
              flex: "1",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                height: "200px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "16px",
              }}
            >
              <DotLoader color={theme.palette.primary.main} />
              <Typography>لطفا منتظر باشید...</Typography>
            </Box>
          </Box>
        ) : !tendersList.length ? (
          <Box
            sx={{
              height: "200px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "16px",
            }}
          >
            <EmptyCargoSVG size={125} color={theme.palette.primary.main} />
            <Typography
              maxWidth={150}
              textAlign={"center"}
              sx={{
                fontWeight: "700",
                color: blueGrey[500],
              }}
            >
              در حال حاضر محموله تکمیل شده ندارید
            </Typography>
          </Box>
        ) : (
          tendersList.map((item, index) => (
            <>
              <Box
                ref={index + 1 === pageN * 10 ? ref : null}
                sx={{
                  flex: "1",
                  borderRadius: "8px",
                  backgroundColor: "bgColor.grey100",
                  display: "flex",
                  justifyContent: "space-between",
                  boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.1) inset",
                  padding: "8px 6px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: "600",
                    }}
                  >
                    راننده: {item.driverFullName}
                  </Typography>
                </Box>
                <Typography
                  sx={{
                    fontSize: "14px",
                  }}
                >
                  {addCommas(item.price)} ریال
                </Typography>
              </Box>
              {isGetTendersListMuttingNextPage &&
                index === tendersList.length - 1 && (
                  <Box
                    sx={{
                      minHeight: "200px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "16px",
                    }}
                  >
                    <DotLoader color={theme.palette.primary.main} />
                    <Typography>لطفا منتظر باشید...</Typography>
                  </Box>
                )}
            </>
          ))
        )}
      </Box>
      <CustomButton
        type="outlined"
        // rippleColor={theme.palette.info.dark}
        // loading
        //   flexDirection="row-reverse"
        onClick={() => setOpen(false)}
        justifyContent="center"
        title="بستن "
        bgColor="secondary.main"
        textColor="#fff"
        // borderColor="error.main"
        fWeight="700"
        fSize="16px"
        px="10px"
        py="12px"
        borderRadius="10px"
        // icon1={
        //   <MultipleSimple color={theme.palette.error.main} size={18} />
        // }
      />
    </ModalLayout>
  );
}
